import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("shoplogintoken");

  if (!token) {
    // Redirect to shoplogin if no token
    return <Navigate to="/shoplogin" replace />;
  }

  return children;
};

export default ProtectedRoute;
